import {BASE_URL} from "@/constants/config";
import {request} from "@/utils/request";

export const USER_ENDPOINTS = {
  me: `${BASE_URL}users/me`,
};

const userKey = 'user';

class User {
  user = null;

  get() {
    if (this.user) {
      return this.user;
    }
    const savedUser = localStorage.getItem(userKey);
    if (savedUser) {
      this.user = JSON.parse(savedUser);
      this.set(this.user);
      return this.user;
    }
  }

  clear() {
    localStorage.removeItem(userKey);
    this.user = null;
  }

  async set(value) {
    if (value) {
      localStorage.setItem(userKey, JSON.stringify(value));
    }
    if (value?.accessToken) {
      // lazy-table requires access_token
      localStorage.setItem('access_token', value.accessToken);
    }
    const userInfo = await this.getUserData();
    if (!userInfo?.id || !value) {
      return;
    }
    const userData = { ...(value || {}), ...userInfo };
    localStorage.setItem(userKey, JSON.stringify(userData));
    this.user = userData;
  }

  addForm(form_id, group_id) {
    this.user.group_form_access.user_forms[form_id] = group_id
    localStorage.setItem(userKey, JSON.stringify(this.user));
  }

  addGroup(group_id) {
    this.user.group_form_access.user_groups[group_id] = "Group Manager";
    localStorage.setItem(userKey, JSON.stringify(this.user));
  }

  getToken() {
    return this.get()?.accessToken;
  }

  setToken(token) {
    return this.set({ accessToken: token });
  }

  getLanguage() {
    return this.get()?.language;
  }

  setLanguage(language) {
    if (language !== this.getLanguage()) {
      return this.set({ ...this.get(), language });
    }
  }

  isAdministrator() {
    return this.get()?.role_id === 1;
  }

  isSuperUser() {
    return this.get()?.is_superuser;
  }

  isGroupManager(group_id=null, form_id=null) {
    this.get();
    if (group_id && group_id.length) {
      const group_keys = Object.keys(this.user?.group_form_access?.user_groups || {})
      return group_keys.includes(group_id) ? this.user?.group_form_access?.user_groups[group_id] === "Group Manager" : false
    }
    if (form_id && form_id.length) {
      const form_keys = Object.keys(this.user?.group_form_access?.user_forms || {})
      return form_keys.includes(form_id) ?
        this.user?.group_form_access?.user_forms[form_id] === "is_fixture" : false
    }
    return false
  }

  isGroupUser(group_id=null, form_id=null) {
    if (this.isGroupManager(group_id, form_id)) {
      return true;
    }
    if (group_id && group_id.length) {
      const group_keys = Object.keys(this.user?.group_form_access?.user_groups || {})
      return group_keys.includes(group_id) ? this.user?.group_form_access?.user_groups[group_id] === "Group User" : false
    }
    if (form_id && form_id.length) {
      const form_keys = Object.keys(this.user?.group_form_access?.user_forms || {})
      return form_keys.includes(form_id) ?
        this.user?.group_form_access?.user_forms[form_id] === "is_fixture" ||
        this.user?.group_form_access?.user_forms[form_id] === "Group User" : false
    }
    return false
  }

  async getUserData() {
    const {data} = await request({
      url: USER_ENDPOINTS.me,
      skipRedirect: true,
    });
    return data;
  }

}

export const ActiveUser = new User();
